import { IFeature } from 'mod/featureV2/interface';
import { stickyTopBar, stickyTopBar2 } from './pc/stickyTopBar';
import { productBanner, productBanner2 } from './pc/productBanner';
import { overlayBanner } from './pc/overlayBanner';
import { banner, bannerLarge } from './pc/banner';
import { anchorsBanner, anchorsBanner2 } from './pc/anchorsBanner';
import { swiperToggleBanner } from './pc/swiperToggleBanner';
import { collapse, collapse2 } from './pc/collapse';
import { techSpecs, techSpecs2 } from './pc/techSpecs';
import { picTxtLinkage, picTxtLinkage2 } from './pc/picTxtLinkage';
import { swiperReviews, swiperReviews2 } from './pc/swiperReviews';
import { buyButton, buyButton2 } from './pc/buyButton';
import { waterFall } from './pc/waterFall';
import { tabsProducts } from './pc/tabsProducts';
import { blog } from './pc/blog';
import { article } from './pc/article';
import { animation } from './pc/animation';
import { scaleVideo } from './pc/scaleVideo';
import { parallax1, parallax2, parallax3 } from './pc/parallax';
import { backToTop } from './pc/backToTop';

export const mockPC: IFeature[] = [
    stickyTopBar,
    stickyTopBar2,
    productBanner,
    productBanner2,
    overlayBanner,
    banner,
    bannerLarge,
    anchorsBanner,
    anchorsBanner2,
    swiperToggleBanner,
    collapse,
    collapse2,
    techSpecs,
    techSpecs2,
    picTxtLinkage,
    picTxtLinkage2,
    swiperReviews,
    swiperReviews2,
    buyButton,
    buyButton2,
    waterFall,
    tabsProducts,
    blog,
    article,
    animation,
    scaleVideo,
    collapse,
    collapse2,
    parallax1,
    parallax2,
    parallax3,
    backToTop,
];